import {
    Component
} from '@angular/core';



@Component({
    selector: 'no-data',
    template: require('./noData.html'),
    styles: [String(require('./noData.styl'))]
})

export class NoDataComponent {


}



// WEBPACK FOOTER //
// ./src/app/components/noData/noData.component.ts